import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { addDoc, collection, getDocs, orderBy, query } from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db } from "../Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual, getUsuarioAtualComTenant } from "../Utils/tenant";
import { AMBIENTE_PRODUCAO, NOME_CLIENTE_DOCUMENTO } from "../Config/branding";

const COLLECTION = "tblAnalisesCriticasDirecao";

const PRIMEIRA_ANALISE = {
  codigo: "ACD-001/2025",
  numeroRegistro: 1,
  versao: AMBIENTE_PRODUCAO ? "01" : "",
  aprovadoEm: AMBIENTE_PRODUCAO ? "2025-09-17" : "",
  dataReuniao: AMBIENTE_PRODUCAO ? "2025-09-17" : "",
  participantes: "José Leal, Silvio, Viviane, Darlei, Paulo Sérgio",
  objetivo: "Registrar a análise crítica do SGQ, avaliando sua adequação, eficácia e alinhamento estratégico, além de propor melhorias, novos recursos e oportunidades de inovação.",
  situacaoAcoesAnteriores: "A primeira análise crítica formal do SGQ foi realizada em 17/09/2025. Desde então, as ações e melhorias propostas foram monitoradas e implementadas.",
  mudancasInternas: "- Consolidação da matriz de riscos, com classificação e monitoramento dos riscos estratégicos e operacionais.\n- Acompanhamento dos indicadores de objetivos da qualidade, incluindo pontualidade de laudos, faturamento, satisfação de clientes e capacitação da equipe.\n- Implementação de melhorias físicas e estruturais no galpão, como pintura, organização de bancadas e otimização de áreas de ensaios.\n- Capacitação contínua da equipe técnica, com treinamentos de normas NR 6, 12 e 18 e atualização em ensaios tecnológicos.\n- Expansão do SGQ com nova POP (11), relacionada a Consultoria em Controle Tecnológico (ensaios e dosagens).",
  mudancasExternas: "Clientes exigindo maior rastreabilidade, CREA-TO mais atuante, aumento da concorrência com preços abaixo da média e novas normas técnicas (NBR 5738/5739).",
  mudancasAmbientais: "- Implementada uma análise de impactos ambientais com foco em práticas sustentáveis, reaproveitamento de resíduos e copos reutilizáveis identificados com o nome de cada colaborador.\n- A empresa adotou o canteiro central em frente à sua sede, realizando o plantio de grama e árvore, com o objetivo de contribuir para a arborização urbana e melhoria da qualidade ambiental local.",
  desempenhoEficacia: "- Indicadores de Qualidade: taxa de laudos entregues no prazo está próxima de 90%, mas a meta é maior ou igual a 95%.\n- NCs e Melhorias: POP 1.2 estruturou bem o fluxo de registro e tratamento. A maioria das não conformidades é classificada como moderada e já tratada dentro do prazo.\n- Objetivos da Qualidade: claros e vinculados ao planejamento estratégico (ex.: faturamento de R$ 30k/mês, ISO 9001 até 2026).",
  feedbackPartesInteressadas: "- Clientes: pesquisas de satisfação indicam boa percepção técnica, mas pedem maior agilidade em coletas.\n- Órgãos reguladores: aproximação positiva com CREA-TO, mas ainda sem parcerias formais.\n- Colaboradores/Estagiários: pesquisa de clima interno revelou necessidade de plano de carreira mais definido e maior clareza em critérios de avaliação.\n- Fornecedores: relação estável, mas dependente de poucos fornecedores de calibração (risco identificado).",
  conformidadeProdutosServicos: "- Ensaios laboratoriais seguem POPs normativos, com registros adequados.\n- Controle tecnológico do concreto é reconhecido como diferencial técnico da empresa.",
  desempenhoFornecedores: "",
  adequacaoRecursos: "- Pessoas: equipe enxuta, mas qualificada; necessidade de ampliar o quadro em 2026 para suportar crescimento.",
  eficaciaRiscosOportunidades: "- Matriz de Riscos: implementada, mas precisa de monitoramento trimestral.\n- Gestão de Mudanças: aplicada a novos ensaios (esclerometria) e atualização de POPs.\n- Conformidade legal: RQ 1.8 consolidado, mas ainda faltam relatórios periódicos de acompanhamento das normas ambientais.",
  oportunidadesMelhoria: "- Digitalização: integrar todos os registros do SGQ em um painel online (Google Data Studio ou Power BI).\n- Sustentabilidade: acelerar a implantação da coleta seletiva e ampliar projetos de reaproveitamento de resíduos.\n- Estratégia: buscar contratos em outros estados e consolidar imagem institucional como referência no Tocantins e Goiás.",
  melhoriaSGQProcessos: "- Revisar POPs críticos (1.2 NCs, 2.2 Concreto, 6 Comercial).\n- Consolidar matriz de riscos com foco em sustentabilidade e compliance.\n- Consolidar indicadores em dashboard único e auditorias internas com relatórios padronizados.\n- Registrar mudanças.\n- Atualizar os indicadores dos objetivos da Qualidade.\n- Realizar as melhorias propostas no galpão (pintura horizontal, bancadas etc.).\n- Atualizar os treinamentos das equipes.\n- Fazer levantamento do volume dos resíduos gerados.",
  melhoriaProdutosServicos: "- Garantir pontualidade maior ou igual a 95% nos laudos.",
  necessidadesRecursos: "- Plano de capacitação contínua (mínimo de 12h/ano por colaborador).",
  alinhamentoEstrategico: "- Integração do Balanced Scorecard ao SGQ.\n- Monitoramento trimestral dos KPIs.\n- Reforço da cultura de melhoria contínua (treinamentos, campanhas internas).",
  documentosReferencia: "- Manual da Qualidade.\n- POPs 1.1, 1.2, 2, 5, 6, 7, 8, 9, 10.\n- RQs 1.2, 1.3, 1.6, 1.7, 1.8.\n- Planejamento Estratégico.",
  itensAvancados: "- Compliance e Ética: necessidade de criação de Código de Conduta Ética.\n- Gestão ESG: propor Relatório de Sustentabilidade Anual, com métricas ambientais e sociais.\n- Inovação: criar indicadores de P&D (número de novos ensaios lançados/ano e número de projetos acadêmicos).\n- Segurança da Informação: fortalecer controles digitais no NextCloud/Drive (backup automático, restrição de acessos e auditoria de logs).\n- Benchmarking: realizar análise comparativa com laboratórios de Goiás e Pará para identificar gaps técnicos e oportunidades comerciais.",
  conclusao: `O SGQ da ${NOME_CLIENTE_DOCUMENTO} está em fase de consolidação, com grande avanço na padronização (POPs, RQs e Planejamento Estratégico).\n\nA eficácia ainda precisa ser fortalecida com maior digitalização, fortalecimento de indicadores e engajamento das partes interessadas.\n\nAs ações propostas permitem alinhar o SGQ ao crescimento estratégico, reforçando a imagem da organização como referência regional e futura player nacional em tecnologia do concreto.\n\nAnálise Crítica, atendendo o Requisito 9.3 - Análise Crítica pela Direção, realizada em reunião com todo o time de qualidade.`,
  aprovadoDirecao: false,
  aprovacaoNome: "",
  aprovacaoData: "",
  aprovacaoUsuario: null,
};

function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

export default function CadastroAnaliseCriticaDirecao() {
  const history = useHistory();
  const [registros, setRegistros] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [carregando, setCarregando] = useState(true);
  const [lancandoPrimeiro, setLancandoPrimeiro] = useState(false);

  useEffect(() => {
    async function carregarRegistros() {
      setCarregando(true);
      try {
        const snapshot = await getDocs(
          consultaTenantAtual(query(collection(db, COLLECTION), orderBy("criadoEm", "desc")))
        );
        setRegistros(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
      } catch (error) {
        console.error("Erro ao carregar análises críticas da direção:", error);
      } finally {
        setCarregando(false);
      }
    }

    carregarRegistros();
  }, []);

  const registrosFiltrados = useMemo(() => {
    const termo = filtro.trim().toLocaleLowerCase("pt-BR");
    if (!termo) return registros;
    return registros.filter((registro) =>
      [registro.codigo, registro.versao, registro.dataReuniao, registro.participantes, registro.responsavel]
        .some((valor) => contemTextoPesquisa(String(valor || "").toLocaleLowerCase("pt-BR"), termo))
    );
  }, [filtro, registros]);

  async function lancarPrimeiroCadastro() {
    if (registros.length > 0 || lancandoPrimeiro) return;

    setLancandoPrimeiro(true);
    try {
      const usuario = await getUsuarioAtualComTenant();
      const agora = new Date();
      const responsavel = String(usuario.nome || usuario.email || "").trim();
      const dados = aplicarTenantAtual({
        ...PRIMEIRA_ANALISE,
        responsavel,
        criadoEm: agora,
        criadoPor: auth.currentUser?.uid || usuario.uid || null,
        criadoPorEmail: auth.currentUser?.email || usuario.email || null,
        atualizadoEm: agora,
        atualizadoPor: auth.currentUser?.uid || usuario.uid || null,
        atualizadoPorEmail: auth.currentUser?.email || usuario.email || null,
      });
      const referencia = await addDoc(collection(db, COLLECTION), dados);
      setRegistros([{ id: referencia.id, ...dados }]);
    } catch (error) {
      console.error("Erro ao lançar o primeiro cadastro de análise crítica:", error);
      alert("Não foi possível lançar o primeiro cadastro.");
    } finally {
      setLancandoPrimeiro(false);
    }
  }

  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: 2, mb: 2, p: 2 }}>
          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2}>
            <Box>
              <Typography variant="h5" fontWeight={700}>Análise Crítica da Direção</Typography>
              <Typography variant="body2" color="text.secondary">RQ 1.5 — Relatórios de análise crítica do Sistema de Gestão da Qualidade.</Typography>
            </Box>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              {!carregando && registros.length === 0 && (
                <Button variant="outlined" onClick={lancarPrimeiroCadastro} disabled={lancandoPrimeiro}>
                  {lancandoPrimeiro ? "Lançando..." : "Lançar primeiro cadastro"}
                </Button>
              )}
              <Button variant="contained" onClick={() => history.push("/app/analise-critica-direcao/novo")}>Novo relatório</Button>
            </Stack>
          </Stack>
          <TextField label="Pesquisar relatório" value={filtro} onChange={(event) => setFiltro(event.target.value)} size="small" fullWidth sx={{ mt: 2 }} />
        </Paper>

        <Paper sx={{ border: "1px solid #e2e8f0", overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900 }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Data da reunião</TableCell>
                <TableCell>Versão</TableCell>
                <TableCell>Participantes</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {registrosFiltrados.map((registro) => (
                <TableRow key={registro.id} hover onClick={() => history.push(`/app/analise-critica-direcao/${registro.id}`)} sx={{ cursor: "pointer" }}>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>{registro.codigo || "-"}</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>{formatarDataBR(registro.dataReuniao)}</TableCell>
                  <TableCell>{registro.versao || "-"}</TableCell>
                  <TableCell>{registro.participantes || "-"}</TableCell>
                  <TableCell sx={registro.preenchimentoIncompleto === true ? { color: "error.main" } : undefined}>{registro.preenchimentoIncompleto === true ? "Preenchimento incompleto" : registro.aprovadoDirecao === true ? "Aprovado" : "Em elaboração"}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Visualizar relatório">
                      <IconButton size="small" onClick={(event) => { event.stopPropagation(); history.push(`/app/analise-critica-direcao/${registro.id}?print=1`); }}>
                        <VisibilityIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                    <span onClick={(event) => event.stopPropagation()}>
                      <HistoricoCadastro colecao={COLLECTION} documentoId={registro.id} registro={registro} />
                    </span>
                  </TableCell>
                </TableRow>
              ))}
              {carregando && <TableRow><TableCell colSpan={6}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando relatórios...</Typography></Box></TableCell></TableRow>}
              {!carregando && registrosFiltrados.length === 0 && <TableRow><TableCell colSpan={6} align="center">Nenhum relatório encontrado.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </>
  );
}
